import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { FontWeights } from 'theme/Typography';

import { previewText } from './TitleBlock.helpers';

export const TitleBlock: FC = () => (
  <Box mt={{ xs: -5, md: -10 }} display="flex" alignItems="center" overflow="hidden" width="100%">
    <Typography
      sx={{
        fontSize: { xs: 24, sm: 48 },
        lineHeight: { xs: '30px', sm: '60px' },
        fontWeight: FontWeights.fontWeightSemiBold,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        animation: 'ticker 20s infinite linear',
        '&::after': {
          content: `"${previewText}"`,
        },
        '@keyframes ticker': {
          '0%': {
            transform: 'translateX(0)',
          },
          '100%': {
            transform: 'translateX(-50%)',
          },
        },
      }}
    >
      {previewText}
    </Typography>
  </Box>
);
